import * as yup from 'yup'

export const schema = yup.object({
  senceState: yup.boolean().required(),
  sence: yup
    .object({
      token: yup.string(),
      runOtec: yup.string(),
    })
    .when('senceState', {
      is: true,
      then: yup.object().shape({
        token: yup.string().required(),
        runOtec: yup.string().required(),
      }),
    })
    .nullable(),
})
export type FormValues = yup.InferType<typeof schema>
